import styled from 'styled-components';

export const Wrapper = styled.div`
  color: #161d1f;
  position: relative;
  display: flex;
  width: 100%;
  &:hover {
    border-color: var(--primary-hover);
  }
  &.filled {
    border-color: var(--primary-focus);
  }
  &.disabled {
    border-color: var(--text-text-disabled);
  }
  & button {
    background-color: #fff;
    border-radius: 4px;
    padding: 0px 8px 0px 0px;
    display: flex;
    align-items: center;
  }

  .menu-wrapper {
    width: 100%;
    min-width: 153px;
    z-index: 1;
    position: absolute;
    background-color: #fff;
    border-radius: 4px;
    max-height: 216px;
    overflow: auto;
    top: 44px;
    text-align: left;
  }
  .menu-wrapper:hover {
    background-color: #fff;
  }
  .menu-wrapper:focus {
    background-color: #fff;
  }
  ul {
    padding: 8px 0;
  }
  li button {
    width: 100%;
    height: 40px;
    text-align: left;
    padding: 10px 16px;
    // display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 0px;
  }
  li button cc-icon {
    margin-right: 10px;
  }
  li button:focus {
    outline: 0;
    background: #a8cbe2;
  }
  li button.empty {
    color: #4f6168;
    display: flex;
  }
  li button:hover {
    background: #d5e5f0;
  }
  li:focus {
    background: red;
  }
  li button.active {
    background: #e2dffd;
  }
  mark {
    color: #5b36f2;
    background-color: transparent;
    font-weight: 900;
  }

  .inputButton:focus {
    border: 1px solid var(--nb-primary);
    border-radius: 0.4rem;
  }
`;

export const InputText = styled.input`
  cursor: pointer;
  border: none !important;
  height: 40px !important;
  background-color: #fff;
  &::placeholder {
    color: var(--text-text01) !important;
    font-size: 14px;
  }
  &:disabled::placeholder {
    color: var(--text-text-disabled) !important;
  }
`;
